<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'

import languageSelectService from '@/services/embeds/plugin/language.select.service'
import { useIdeStore } from '@/stores/embeds/ide.store'
import { useEmbedConfigureStore } from '@/stores/embeds/embedConfigure.store'

const ideStore = useIdeStore()
const embedConfigStore = useEmbedConfigureStore()

const { getOnEditMode, getLanguageMeta, getEmbedConfig } = storeToRefs(embedConfigStore)
const { getLanguageListHideTitle, getLanguageListTitleName, getLanguageListDisplay } =
  storeToRefs(ideStore)

const languages = computed(() => {
  return getEmbedConfig.value?.languages || []
})

/**
 * @description get language display name
 * @param name - The language name
 * @returns The language display name
 */
const languageDisplayName = (name: string) => {
  const languageMetaItem: any = getLanguageMeta.value[name]
  return languageMetaItem.langDisplayName || languageMetaItem.langName
}
/**
 * @description on select language
 */
const onSelectLanguageChange = () => {
  languageSelectService.onSelectLanguageChange()
}
onMounted(async () => {
  await new Promise((resolve) => setTimeout(resolve, 100))
  if (getOnEditMode.value == false) {
    languageSelectService.initLanguageList()
    languageSelectService.onSettingChange()
  }
})
onBeforeUnmount(async () => {
  if (getOnEditMode.value === false) {
    languageSelectService.destroyLanguageList()
  }
  await new Promise((resolve) => setTimeout(resolve, 100))
})
</script>

<template>
  <div
    :class="[
      'flex h-full w-full gap-2 ',
      {
        'flex-col': !getLanguageListDisplay
      },
      {
        'flex-row items-center': getLanguageListDisplay
      }
    ]"
  >
    <label v-if="getLanguageListHideTitle" class="min-w-fit font-semibold leading-6">
      {{ getLanguageListTitleName }}</label
    >
    <select
      class="block h-12 w-full rounded-md border border-gray-400 px-2 outline-none"
      v-model="ideStore.selectedLanguage"
      :disabled="languages.length <= 0"
      @change="onSelectLanguageChange()"
    >
      <option v-for="(language, index) in languages" :key="index" :value="language">
        {{ languageDisplayName(language.language) }}
      </option>
    </select>
  </div>
</template>
